/** Shared API base URL for admin HTTP clients (Docker default: localhost:8080). */
export const SERVER_API_BASE =
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';

export const SERVER_API_V1 = `${SERVER_API_BASE}/api/v1`;
export const SERVER_API_V2 = `${SERVER_API_BASE}/api/v2`;
